import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  currentProfile,
  currentUser,
  setProfileData,
} from "src/common/services";
import withServices from "src/HOCs/withServices";
import Navbar from "../../../components/CustomNav/CustomNav.Component";
import {
  Container,
  Column,
  Row,
  Title,
  DetailsWrapper,
  Detail,
  InputWrapper,
} from "../ProfilePage.styles";

interface Props {
  services: any;
  history: any;
}
interface State {
  toLogin: boolean;
  fname: string;
  lname: string;
  currentpass: string;
  newpass: string;
  confirmpass: string;
  passmatch: boolean;
  currentfname: string;
  currentlname: string;
  field_1: string;
  field_2: string;
  field_3: string;
  field_4: string;
  field_5: string;
  userProfile: any;
  leadName: string;
  leadPhone: string;
  leadEmail: string;
  schoolPhone: string;
  profileLoaded: boolean;
  subscriptionInfo: any;
}

class SchoolProfilePage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      toLogin: false,
      fname: "John",
      lname: "Node",
      currentpass: "",
      newpass: "",
      confirmpass: "",
      passmatch: true,
      currentfname: "John",
      currentlname: "Node",
      field_1: "URN",
      field_2: "Field 2",
      field_3: "Field 3",
      field_4: "Field 4",
      field_5: "Field 5",
      userProfile: {},
      subscriptionInfo: {},
      leadName: "",
      leadPhone: "",
      leadEmail: "",
      schoolPhone: "",
      profileLoaded: false,
    };

    this.updatePasswordHandler = this.updatePasswordHandler.bind(this);
    this.updateContactsHandler = this.updateContactsHandler.bind(this);
    this.updateSchoolFieldsHandler = this.updateSchoolFieldsHandler.bind(this);
    this.handleCancelSubscription = this.handleCancelSubscription.bind(this);
  }

  public async componentDidMount() {
    const {
      services: { adminAPI, isUserLoggedIn },
    } = this.props;
    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    } else {
      const userInfoRes = await this.props.services.adminAPI.fetchUserInfo();
      if (userInfoRes.ok) {
        const userProfile = userInfoRes.data.user_profile;
        const fieldConfig = userProfile.Profiledata.field_config;
        this.setState({
          ...this.state,
          ...fieldConfig,
          userProfile,
          subscriptionInfo: userInfoRes.data.subscription,
          profileLoaded: true,
        });
      }
    }
  }

  public onLogout = () => {
    this.setState({ toLogin: true });
  };

  public handleChange = (field, e) => {
    if (field === "fname") {
      this.setState({ fname: e.target.value });
    }
    if (field === "lname") {
      this.setState({ lname: e.target.value });
    }
    if (field === "currentpass") {
      this.setState({ currentpass: e.target.value });
    }
    if (field === "newpass") {
      this.setState({ newpass: e.target.value });
    }
    if (field === "confirmpass") {
      const { newpass, confirmpass } = this.state;
      this.setState({
        confirmpass: e.target.value,
        passmatch: newpass === e.target.value,
      });
    }
    if (field === "field1") {
      this.setState({ field_1: e.target.value });
    }
    if (field === "field2") {
      this.setState({ field_2: e.target.value });
    }
    if (field === "field3") {
      this.setState({ field_3: e.target.value });
    }
    if (field === "field4") {
      this.setState({ field_4: e.target.value });
    }
    if (field === "field5") {
      this.setState({ field_5: e.target.value });
    }

    if (field === "leadName") {
      this.setState({ leadName: e.target.value });
    }
    if (field === "leadEmail") {
      this.setState({ leadEmail: e.target.value });
    }
    if (field === "leadPhone") {
      this.setState({ leadPhone: e.target.value });
    }
    if (field === "schoolPhone") {
      this.setState({ schoolPhone: e.target.value });
    }
  };

  public async updatePasswordHandler() {
    const {
      services: { adminAPI },
    } = this.props;
    const { newpass, currentpass, confirmpass } = this.state;

    if (newpass === confirmpass && newpass !== "") {
      const item = {
        new_password: newpass,
        old_password: currentpass,
      };
      const res = await adminAPI.updatePassword(item);
      if (res.status === 200) {
        toast.success("Password Change Successful");
      } else if (res.status === 400) {
        toast.error("Your old password is incorrect");
      }
    } else {
      this.setState({ passmatch: false });
    }
  }

  public async handleCancelSubscription() {
    const {
      services: { institutionsAPI },
    } = this.props;
    const cancelRes = await institutionsAPI.cancelSubscription();
    if (cancelRes.ok) {
      toast.success(
        "Subscription cancelled, get another subscription to continue using Performance Learning."
      );
    }
  }
  public onUpdateSubscription = () => {
    const {
      history,
      services: { currentBaseUrl },
    } = this.props;
    history.push(`${currentBaseUrl}purchase`);
  };

  public async updateContactsHandler() {
    const {
      services: { institutionsAPI },
    } = this.props;
    const { leadName, leadPhone, leadEmail, schoolPhone } = this.state;
    const item = {
      pl_lead_email: leadEmail,
      pl_lead_name: leadName,
      pl_lead_phone: leadPhone,
      school_phone: schoolPhone,
    };
    // if (fname !== currentfname || lname !== currentlname) {
    //   const res = await adminAPI.updateUserProfileInfo(item);
    //   console.log(JSON.stringify(res, null, 2));
    // }
    const res = await institutionsAPI.updateInstitutionsContact(item);
    if (res.ok) {
      toast.success("Contact Details Updated!");
    } else {
      toast.error("Please try again later");
    }
  }

  public async updateSchoolFieldsHandler() {
    const { field_1, field_2, field_3, field_4, field_5 } = this.state;
    const {
      services: { institutionsAPI },
    } = this.props;
    const item = {
      field_1,
      field_2,
      field_3,
      field_4,
      field_5,
    };
    const res = await institutionsAPI.updateCustomFields(item);
    if (res.ok) {
      toast.success("Fields Updated");
      const userInfoRes = await this.props.services.adminAPI.fetchUserInfo();
      if (userInfoRes.ok) {
        setProfileData(userInfoRes.data.user_profile.Profiledata);
      } else {
        toast.info("Your changes will show next time you log in.");
      }
    } else {
      toast.error("Fields not updated");
    }
  }

  public renderUserDetails = () => {
    const { userProfile, profileLoaded } = this.state;
    if (profileLoaded) {
      return (
        <React.Fragment>
          <Column background={true} width="45%">
            <DetailsWrapper>
              <Detail>
                <h3>Name</h3>
                <p
                  style={{ textTransform: "capitalize" }}
                  className="detail-value"
                >
                  {currentUser() || this.state.userProfile.User}
                </p>
              </Detail>
              <Detail>
                <h3>Code</h3>
                <p className="detail-value">
                  {this.state.userProfile.ParentStudentCode}
                </p>
              </Detail>
            </DetailsWrapper>
            <InputWrapper>
              <p>Lead Name</p>
              <input
                type="text"
                id="lead-name"
                className="custom-textfield"
                placeholder={
                  userProfile.Profiledata.contact_info
                    ? userProfile.Profiledata.contact_info.pl_lead_name
                    : "School Lead Name"
                }
                required={true}
                data-arg="lead-name"
                value={this.state.leadName}
                onChange={this.handleChange.bind(this, "leadName")}
              />
            </InputWrapper>
            <InputWrapper>
              <p>Lead Email</p>
              <input
                type="text"
                id="lead-email"
                className="custom-textfield"
                placeholder={
                  userProfile.Profiledata.contact_info
                    ? userProfile.Profiledata.contact_info.pl_lead_email
                    : "School Lead Email"
                }
                required={true}
                data-arg="lead-email"
                onChange={this.handleChange.bind(this, "leadEmail")}
                value={this.state.leadEmail}
              />
            </InputWrapper>
            <InputWrapper>
              <p>Lead Phone</p>
              <input
                type="text"
                id="lead-phone"
                className="custom-textfield"
                placeholder={
                  userProfile.Profiledata.contact_info
                    ? userProfile.Profiledata.contact_info.pl_lead_phone
                    : "School Lead Phone"
                }
                required={true}
                data-arg="lead-phone"
                onChange={this.handleChange.bind(this, "leadPhone")}
                value={this.state.leadPhone}
              />
            </InputWrapper>
            <InputWrapper>
              <p>School Phone</p>
              <input
                type="text"
                id="school-phone"
                className="custom-textfield"
                placeholder={
                  userProfile.Profiledata.contact_info
                    ? userProfile.Profiledata.contact_info.school_phone
                    : "School Phone"
                }
                required={true}
                data-arg="school-phone"
                onChange={this.handleChange.bind(this, "schoolPhone")}
                value={this.state.schoolPhone}
              />
            </InputWrapper>
            <button
              className="green-button update-details"
              onClick={this.updateContactsHandler}
            >
              Update School Details
            </button>
          </Column>
        </React.Fragment>
      );
    } else {
      return "";
    }
  };

  public renderChangePassword = () => {
    return (
      <Column width="45%" height="400px" background={true}>
        <InputWrapper>
          <p>Enter your current password</p>
          <input
            type="password"
            id="current-password"
            className="custom-textfield"
            placeholder="Enter your current password"
            required={true}
            data-arg="current-pass"
            onChange={this.handleChange.bind(this, "currentpass")}
          />
        </InputWrapper>
        <InputWrapper>
          <p>Enter a new password</p>
          <input
            type="password"
            id="new-password"
            className="custom-textfield"
            placeholder="Enter new password"
            required={true}
            data-arg="new-pass"
            onChange={this.handleChange.bind(this, "newpass")}
          />
        </InputWrapper>
        <InputWrapper>
          <p>Confirm your new password</p>
          <input
            type="password"
            id="confirm-password"
            className="custom-textfield"
            placeholder="Confirm your new password"
            required={true}
            data-arg="confirm-pass"
            onChange={this.handleChange.bind(this, "confirmpass")}
          />
        </InputWrapper>
        <p
          style={{
            display: this.state.passmatch ? "none" : "block",
            color: "#ff0033",
          }}
        >
          Passwords don't match
        </p>
        <button
          className="green-button update-details"
          onClick={this.updatePasswordHandler}
        >
          Update Password
        </button>
      </Column>
    );
  };

  // public renderSubscriptionDetail = () => {
  //   return (
  //     <Column background={true} width="45%" height="500px">
  //       <p>Subscription Details Coming</p>
  //     </Column>
  //   );
  // };

  public renderCustomFields = () => {
    const { field_1, field_2, field_3, field_4, field_5 } = this.state;
    return (
      <Column width="45%" height="560px" background={true}>
        <p>You can give these fields a custom name </p>
        <InputWrapper>
          <p>Field 1</p>
          <input
            type="text"
            id="field-1"
            className="custom-textfield"
            placeholder="URN"
            required={true}
            data-arg="field-1"
            value={field_1}
            onChange={this.handleChange.bind(this, "field1")}
          />
        </InputWrapper>
        <InputWrapper>
          <p>Field 2</p>
          <input
            type="text"
            id="field-2"
            className="custom-textfield"
            placeholder="Field 2"
            required={true}
            data-arg="field-2"
            value={field_2}
            onChange={this.handleChange.bind(this, "field2")}
          />
        </InputWrapper>
        <InputWrapper>
          <p>Field 3</p>
          <input
            type="text"
            id="field-3"
            className="custom-textfield"
            placeholder="Field 3"
            required={true}
            data-arg="field-3"
            value={field_3}
            onChange={this.handleChange.bind(this, "field3")}
          />
        </InputWrapper>
        <InputWrapper>
          <p>Field 4</p>
          <input
            type="text"
            id="field-4"
            className="custom-textfield"
            placeholder="Field 4"
            required={true}
            data-arg="field-4"
            value={field_4}
            onChange={this.handleChange.bind(this, "field4")}
          />
        </InputWrapper>
        <InputWrapper>
          <p>Field 5</p>
          <input
            type="text"
            id="field-5"
            className="custom-textfield"
            placeholder="Field 5"
            required={true}
            data-arg="field-5"
            value={field_5}
            onChange={this.handleChange.bind(this, "field5")}
          />
        </InputWrapper>

        <button
          className="green-button update-details"
          onClick={this.updateSchoolFieldsHandler}
        >
          Update Your Fields
        </button>
      </Column>
    );
  };
  public renderSubscriptionDetail = () => {
    const { subscriptionInfo, profileLoaded } = this.state;

    if (profileLoaded) {
      const today = new Date();
      const expiry = new Date(subscriptionInfo.NextPaymentDate);
      const daysLeft = Math.round(
        (expiry.getTime() - today.getTime()) / (1000 * 3600 * 24)
      );
      return (
        <Column width="45%" height="200px" background={true}>
          <h1 className="details-heading">Subscription Details</h1>
          <DetailsWrapper>
            <Detail>
              <h3>
                {subscriptionInfo.PackageName} {subscriptionInfo.Name}
              </h3>
            </Detail>
          </DetailsWrapper>
          {/* <p>You can change some subscription details below</p> */}
          <DetailsWrapper width="80%">
            <button
              className="update-details"
              onClick={this.handleCancelSubscription}
              style={{ color: "#fff", backgroundColor: "#acff2460" }}
            >
              Cancel Membership
            </button>
            <button
              className="green-button update-details"
              onClick={this.onUpdateSubscription}
              style={{ display: "none" }}
            >
              Upgrade
            </button>
          </DetailsWrapper>
        </Column>
      );
    } else {
      return "";
    }
  };

  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    return (
      <div style={{ width: "100vw", height: "100vh" }}>
        <ToastContainer />
        <Navbar logoutParent={this.onLogout} />
        <Container margin="3em 0">
          <Row width="80%">
            {this.renderUserDetails()}
            {this.renderChangePassword()}
          </Row>
          <Row width="80%">
            {this.renderCustomFields()}
            {this.renderSubscriptionDetail()}
          </Row>
        </Container>
      </div>
    );
  }
}

export default withServices(SchoolProfilePage);



// WEBPACK FOOTER //
// ./src/pages/Profile/School/SchoolProfilePage.Component.tsx